import { graphql, useStaticQuery } from "gatsby"
import React, { useState, useContext, useEffect } from "react"
import { injectIntl, navigate, Link } from "gatsby-plugin-intl"

import Cookies from "js-cookie"
import config from "../utils/magento/m2config"
import { localize } from "../utils"
import Image from "./image"
import {
  LanguageSelect,
  LanguageSelectMobile,
} from "../components/languageSelect"
import {
  UilBars,
  UilTimes,
  UilAngleLeft,
} from "@iconscout/react-unicons"

import { Context } from "../context/Context"
import { groupBy, keyBy, orderBy } from "lodash"

const Header = ({ intl }) => {
  const { cart } = useContext(Context)
  const [menuOpen, setMenuOpen] = useState(false)
  const [cartEmpty, setCartEmpty] = useState(true)
  const [selectedPL, setSelectedPL] = useState()
  const [selectedCategory, setSelectedCategory] = useState()
  const [dropdownOpen, setDropdownOpen] = useState(false)

  const data = useStaticQuery(graphql`
    query Header {
      allDirectusEcommerce {
        nodes {
          data {
            lang
            striscia
          }
        }
      }
      allDirectusVariable {
        nodes {
          navigation_links {
            url
            id
          }
        }
      }
      allDirectusProductLine {
        nodes {
          directusId
          ordine
          sezione
          data {
            lang
            name
            description
            slug
          }
        }
      }
      allDirectusCategory {
        nodes {
          product_line {
            directusId
          }
          data {
            name
            slug
            lang
          }
          directusId
        }
      }
      allDirectusProduct {
        nodes {
          item_id
          id
          hidden
          category {
            directusId
          }
          order
          data {
            name
            slug
            lang
            long_description
          }
        }
      }
      allDirectusMarketingLinea {
        nodes {
          data {
            body
            lang
            title
            slug
            testo_menu
            immagine {
              private_hash
              localFile {
                childImageSharp {
                  fixed(height: 520) {
                    srcSet
                    srcSetWebp
                  }
                }
              }
            }
          }
          linea {
            directusId
          }
        }
      }
      allDirectusMarketingCategoria {
        nodes {
          data {
            body
            lang
            title
            slug
            testo_menu
            immagine {
              private_hash
              localFile {
                childImageSharp {
                  fixed(height: 520) {
                    srcSet
                    srcSetWebp
                  }
                }
              }
            }
          }
          category {
            directusId
          }
        }
      }
    }
  `)

  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
    setDropdownOpen(false)
  }

  useEffect(() => {
    if (cart && cart.items && cart.items.length > 0) {
      setCartEmpty(false)
    } else setCartEmpty(true)
  }, [cart])

  const goToCart = () => {
    const magentoUrl = config.externalCheckout.cmsUrl
    // TODO: al lancio di store internazionale mettere il locale
    const store = "it" // intl.locale
    const syncUrlPath = config.externalCheckout.syncUrlPath
    const cartToken = Cookies.get(config.cookies.cartCookieName)
    window.location.replace(
      `${magentoUrl}/${store}${syncUrlPath}/token//cart/${cartToken}`
    )
  }

  const navigateMktg = navigateMenu => {
    navigate(`/marketing/${navigateMenu.slug}?mkt=1`)
  }

  const links = data.allDirectusVariable.nodes[0].navigation_links // data.navigation_links

  const menuProductLines = groupBy(
    orderBy(
      data.allDirectusProductLine.nodes.map(plData =>
        localize(plData, intl.locale)
      ),
      "ordine"
    ),
    "sezione"
  )

  const menuProductCategories = groupBy(
    data.allDirectusCategory.nodes.map(plData => {
      const data = localize(plData, intl.locale)
      return {
        ...data,
        productLineId: data.product_line?.directusId,
      }
    }),
    "productLineId"
  )

  const menuProducts = groupBy(
    data.allDirectusProduct.nodes.map(plData => {
      const data = localize(plData, intl.locale)
      return {
        ...data,
        categoryId: data.category?.directusId,
      }
    }).filter(d => !d.hidden),
    "categoryId"
  )

  const marketingLinea = keyBy(
    data.allDirectusMarketingLinea.nodes.map(mktg => {
      const data = localize(mktg, intl.locale)
      return {
        ...data,
        lineaId: data.linea?.directusId,
      }
    }),
    "lineaId"
  )

  const marketingCat = keyBy(
    data.allDirectusMarketingCategoria.nodes.map(mktg => {
      const data = localize(mktg, intl.locale)
      return {
        ...data,
        catId: data.category?.directusId,
      }
    }),
    "catId"
  )

  const marketingMenu = selectedCategory
    ? marketingCat[selectedCategory?.directusId]
    : marketingLinea[selectedPL?.directusId]

  const ecommerce = localize(data.allDirectusEcommerce?.nodes[0], intl.locale)

  return (
    <>
      <header
        className={`c-header displayFlex ${menuOpen ? "is-menu-open" : ""}`}
        onMouseLeave={() => setDropdownOpen(false)}
      >
        {/* DropDown*/}
        <div className={`c-header__dropdown ${dropdownOpen ? "is-open" : ""}`}>
          <div
            className={`c-header__dropdown__lines c-header__drowdown__col 
            ${selectedCategory || selectedPL ? "is-hidden" : ""}`}
          >
            {Object.keys(menuProductLines)
              .sort()
              .reverse()
              .map(plGroup => {
                return (
                  <div className="c-header__dropdown__line">
                    <h4 className="c-header__dropdown__line__title">
                      {intl.formatMessage({
                        id: `nav.${plGroup.toLowerCase()}`,
                      })}
                    </h4>
                    <ul className="c-header__dropdown__line__list">
                      {menuProductLines[plGroup].map(line => {
                        return (
                          <li
                            className={`c-header__dropdown__item ${
                              line.directusId === selectedPL &&
                              selectedPL.directusId
                                ? "is-active"
                                : ""
                            }`}
                            onClick={() => {
                              setSelectedPL(line)
                              setSelectedCategory(null)
                            }}
                          >
                            {line.name}
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                )
              })}
          </div>

          <div
            className={`c-header__dropdown__results c-header__drowdown__col ${
              selectedPL ? "is-active" : ""
            }`}
          >
            {selectedCategory && (
              <div
                className="c-header__dropdown__category__title"
                onClick={() => {
                  setSelectedCategory(null)
                }}
              >
                <UilAngleLeft size={20} />
                {selectedCategory.name}
              </div>
            )}

            {selectedPL && !selectedCategory && (
              <div
                className={`c-header__dropdown__results__inner is-category ${
                  menuProductCategories[selectedPL.directusId].length > 6
                    ? "is-multicolumn"
                    : ""
                }`}
              >
                <div
                  className="c-header__dropdown__results__header"
                  onClick={() => {
                    setSelectedPL(null)
                    setSelectedCategory(null)
                  }}
                >
                  <UilAngleLeft
                    className="c-header__dropdown__results__header__icon"
                    size={20}
                  />
                  <span className="header__dropdown__results__header__title">
                    {selectedPL.name}
                  </span>
                </div>
                {menuProductCategories[selectedPL.directusId].map(category => {
                  return (
                    <span
                      className={`c-header__dropdown__item`}
                      onClick={() =>
                        menuProducts[category.directusId].filter(
                          prod => !!prod.long_description
                        ).length > 0
                          ? setSelectedCategory(category)
                          : navigate(
                              `/prodotti/${selectedPL.slug}/${category.slug}`
                            )
                      }
                    >
                      {category.name}
                    </span>
                  )
                })}
              </div>
            )}

            {selectedCategory && (
              <div
                className={`c-header__dropdown__results__inner is-product ${
                  menuProducts[selectedCategory.directusId].length > 6
                    ? "is-multicolumn"
                    : ""
                }`}
              >
                <div
                  className="c-header__dropdown__results__header"
                  onClick={() => setSelectedCategory(null)}
                >
                  <UilAngleLeft
                    className="c-header__dropdown__results__header__icon"
                    size={20}
                  />
                  <span className="header__dropdown__results__header__title">
                    {selectedCategory.name}
                  </span>
                </div>

                {selectedCategory && (
                  <>
                    {menuProducts[selectedCategory.directusId]
                      .filter(prod => !!prod.long_description)
                      .map(product => {
                        return (
                          <span
                            className="c-header__dropdown__item"
                            onClick={() =>
                              navigate(`/prodotto/${product.item_id}`)
                            }
                          >
                            {product.name}
                          </span>
                        )
                      })}
                    <span
                      className="c-header__dropdown__item c-header__dropdown__item__all"
                      onClick={() =>
                        navigate(
                          `/prodotti/${selectedPL.slug}/${selectedCategory.slug}`
                        )
                      }
                    >
                      {intl.formatMessage({ id: "nav.vedi_tutti" })}
                    </span>
                  </>
                )}
              </div>
            )}
          </div>

          {marketingMenu && (
            <div className="c-header__dropdown__editorial c-header__drowdown__col">
              <div className="c-header__dropdown__editorial__image">
                <Image image={marketingMenu.immagine} />
              </div>
              <div className="c-header__dropdown__editorial__content">
                <h4>{marketingMenu.title}</h4>
                <p>{marketingMenu.testo_menu}</p>
                <button
                  className="a-btn a-btn--primary"
                  onClick={() => navigateMktg(marketingMenu)}
                >
                  {intl.formatMessage({ id: "terms.discover_mktg" })}
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Header*/}
        <div className="c-header__inner">
          <div className="c-header__hamburger" onClick={toggleMenu}>
            <UilBars
              size="30"
              className="c-header__hamburger-icon"
              style={{
                opacity: menuOpen ? 0 : 1,
              }}
            />
            <UilTimes
              size="30"
              className="c-header__hamburger-icon"
              style={{
                opacity: menuOpen ? 1 : 0,
              }}
            />
          </div>
          <div className="c-header__logo">
            <Link to="/">
              <img
                src="/logo.svg"
                alt={intl.formatMessage({ id: "title" })}
                className="c-header__logo__image"
              />
            </Link>
          </div>
          <div
            className={`c-header__menu ${
              menuOpen ? "c-header__menu--open" : ""
            }`}
          >
            {links.map(link => {
              if (link.urls) {
                const url = link.urls[intl.locale] || link.urls["default"]
                return (
                  <a
                    key={link.id}
                    href={url}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {intl.formatMessage({ id: link.id })}
                  </a>
                )
              }
              if (link.url && link.url.includes("https")) {
                return (
                  <a
                    key={link.id}
                    href={link.url}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {intl.formatMessage({ id: link.id })}
                  </a>
                )
              }
              if (link.id === "nav.prodotti") {
                return (
                  <a
                    onMouseEnter={() =>
                      setDropdownOpen(link.id === "nav.prodotti")
                    }
                    onClick={e => {
                      setDropdownOpen(link.id === "nav.prodotti")
                    }}
                  >
                    {" "}
                    {intl.formatMessage({ id: link.id })}
                  </a>
                )
              }
              return (
                <Link
                  activeClassName="active"
                  partiallyActive={link.url !== "/" ? true : false}
                  key={link.id}
                  to={link.url}
                  onMouseEnter={() =>
                    setDropdownOpen(link.id === "nav.prodotti")
                  }
                  onClick={e => {
                    setDropdownOpen(link.id === "nav.prodotti")
                  }}
                >
                  {intl.formatMessage({ id: link.id })}
                </Link>
              )
            })}
            <div className="c-header__menu-lang">
              <LanguageSelectMobile />
            </div>
          </div>
          <div className="c-header__actions">
            <div className="c-header__lang">
              <LanguageSelect />
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

export default injectIntl(Header)
